/// <reference path="Chart.js" />
import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import BarChartIcon from '../../src/components/css/dark/img/theme-images/bar-chart-icon.svg';
import BarChartIconInactive from '../../src/components/css/dark/img/theme-images/bar-chart-inactive.svg';
import listingIcon from '../../src/components/css/dark/img/theme-images/listing-icon.svg';
import listingIconActive from '../../src/components/css/dark/img/theme-images/listing-icon-active.svg';
import exportIcon from '../../src/components/css/dark/img/theme-images/export.svg';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import ColorJson from '../../src/whitelabel.json';
if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
    import("./css/dark/rxhacker.css")
} else {
    import("./css/dark/main.css")
}
const { AbortController } = window;
class MultiLine_Listchart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            chartData: [],
            columnData: [],
            options: {
                maintainAspectRatio: false,
            },
            IsDataLoaded: false,
            XlabelString: this.props.XlabelString,
            YlabelString: this.props.YlabelString,
            IFrameId: this.props._Index,
            LegendText1: '',
            LegendValue1: '',
            LegendText2: '',
            LegendValue2: '',
            activePage: 1,
            noDataDisplay: '',
            ColorCode: this.props.data.ColorCode,
            sumOfLegendValue: ''
        };
        this.abortController = null;
        this.debounceTimer = null;
    }
    handleFlip(event) {
        $(event.target).parent().next().toggleClass('flipped');
        $(event.target).toggleClass('active');
        $(event.target).parent().toggleClass('active');
    }
    ExportWidget = (event) => {
        try {
            var data = "";
            var tableData = [];
            for (var i = 0; i < this.state.columnData.length; i++) {
                var rowData = [];
                for (var j = 0; j < this.state.columnData[i]["datasets"].length; j++) {
                    rowData.push(' ' + this.state.columnData[i]["datasets"][j]["data"].split(',').join(''));
                }
                tableData.push(rowData.join(","));
            }
            data += tableData.join("\n");
            if (window.navigator.msSaveOrOpenBlob) {
                // IE11
                window.navigator.msSaveOrOpenBlob(new Blob([data]), $(event.target).attr('widget-title') + ".csv");
            } else {
                // Modern browsers
                const blob = new Blob([data], { type: "text/csv" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.id = 'download-link';
                link.download = $(event.target).attr('widget-title') + ".csv";
                link.href = url;
                document.body.appendChild(link);

                // Ensure DOM is ready, then click
                setTimeout(() => {
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url); // Clean up memory
                }, 0);
            }
        } catch (error) { }
    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "MultiLine_List") {
            //console.log("update Column", this.props)
            this.fetchData_locally();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "MultiLine_List") {
            this.fetchData_locally();
        }
        window.Chart.defaults.global.defaultFontFamily = `'Fira Sans', sans-serif`;
    }
    Randomcolor_Random() {

        return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
    }
    Randomcolor(i) {

        // return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
        if (i % 10 == 0) {
            return '#39D890';
        } else if (i % 9 == 0) {
            return '#39D7D8';
        } else if (i % 8 == 0) {
            return '#FD775C';
        } else if (i % 7 == 0) {
            return '#80E166';
        } else if (i % 6 == 0) {
            return '#6AC7F1';
        } else if (i % 5 == 0) {
            return '#0282FB'
        } else if (i % 4 == 0) {
            return '#CB62FF'
        } else if (i % 3 == 0) {
            return '#7F84E8'
        } else if (i % 2 == 0) {
            return '#FCE048'
        } else {
            return '#FFBA10'
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    handleBarList(event) {
        if ($(window).width() < 850) {
            $(event.target).parents('.custom-tooltip').parent().siblings('.flip-bg').toggleClass('flipped');
            $(event.target).siblings('.flip_icon').toggleClass('active');
            $(event.target).siblings('.flip_icon').parent().toggleClass('active');
            $(event.target).parents('.flip-section').children('.flip-icons').hide();
            $(event.target).parents('.flip-section').children('.mobileExportLabel').hide();
            $(event.target).parents('.flip-section').children('.onlyList').children('.export_icon').hide();
        }
    }
    mobileMenu(event) {
        $('.flip-icons').hide();
        $('.export_icon').hide();
        $('.mobileExportLabel').hide();
        if ($(event.target).parents('.flip-section').children('.flip-icons').hasClass('active')) {
            $(event.target).parents('.flip-section').children('.flip-icons').show();
            $('.mobile_bar_icon').show();
            $('.mobileBarLabel').show();
            $(event.target).parents('.flip-section').children('.mobileExportLabel').show();
            $(event.target).parents('.flip-section').children('.onlyList').children('.export_icon').show();
            $('.mobileListLabel').hide();
            $('.mobile_list_icon').hide();
        } else {
            $(event.target).parents('.flip-section').children('.flip-icons').show();
            $('.mobile_list_icon').show();
            $('.mobileListLabel').show();
            $(event.target).parents('.flip-section').children('.mobileExportLabel').show();
            $(event.target).parents('.flip-section').children('.onlyList').children('.export_icon').show();
            $('.mobileBarLabel').hide();
            $('.mobile_bar_icon').hide();
        }
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }

    fetchData_locally() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        let data_available = '';
        this.setState({
            IsDataLoaded: false,
            noDataDisplay: 'Loading. Please wait.'
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1, 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson,
            signal //  attach abort signal here
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                var labels = [];
                var newData = [];
                var repeatData = [];
                if (apidata.length > 0) {
                    for (var i = 0; i < apidata[0].lineDataSet[0].datasets.length - 1; i++) {
                        labels.push(apidata[0].lineDataSet[0].datasets[i]["x"]);
                    }
                    for (var i = 0; i < apidata[0].lineDataSet[0].datasets.length - 1; i++) {
                        newData.push(apidata[0].lineDataSet[0].datasets[i]["y"]);
                    }
                    for (var i = 0; i < apidata[0].lineDataSet2[0].datasets.length - 1; i++) {
                        repeatData.push(apidata[0].lineDataSet2[0].datasets[i]["y"]);
                    }
                }
                //--------------------------------Line Chart Data Handling Start Here-------------------------
                try {
                    this.setState({ LegendText1: apidata[0].legend[0].legendText, LegendValue1: apidata[0].legend[0].legendValue, LegendText2: apidata[0].legend[1].legendText, LegendValue2: apidata[0].legend[1].legendValue });
                    this.setState({ sumOfLegendValue: apidata[0].sumOfLegendValues[0].sumOfLegendValue });
                    // data not available
                    data_available = apidata[0].lineDataSet[0].datasets.length <= 1 ? 'No Data Available' : '';
                    this.setState({ activePage: 1 });
                }
                catch (error) {
                }
                if (!signal.aborted) {
                    this.setState({
                        IsDataLoaded: true,
                        noDataDisplay: data_available
                    });
                }

                try {
                    var wlBorder;
                    var wlHoverBg;
                    if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
                        wlBorder = ColorJson.ApplicationColor.Rxhacker_secondary_color;
                        wlHoverBg = ColorJson.ApplicationColor.Rxhacker_extra_color;
                    } else {
                        wlBorder = '#2A524B';
                        wlHoverBg = '#FF8B6C';
                    }

                    //var topLabel = apidata[0].toplabel,
                    var New_Trans = {
                        label: apidata[0].lineDataSet[0].toplabel,
                        data: newData,
                        borderColor: wlBorder,
                        backgroundColor: '#fff',
                        pointBackgroundColor: '#fff',
                        pointBorderColor: wlBorder,
                        pointBorderWidth: 2,
                        fill: false,
                        hoverBackgroundColor: wlHoverBg
                    };
                    var Repeat_Trans = {
                        label: apidata[0].lineDataSet2[0].toplabel,
                        data: repeatData,
                        borderColor: this.state.ColorCode,
                        backgroundColor: this.state.ColorCode,
                        pointBackgroundColor: '#fff',
                        pointBorderColor: this.state.ColorCode,
                        pointBorderWidth: 2,
                        fill: false,
                        hoverBackgroundColor: wlHoverBg
                    };
                    var leftPosition;
                    var cOverride = this.state.LegendText;
                    this.setState({
                        ...this.state,
                        IsDataLoaded: true,
                        noDataDisplay: data_available,
                        chartData: [
                            {
                                labels: labels,
                                datasets: [New_Trans, Repeat_Trans]
                            }
                        ],
                        options: {
                            layout: {
                                padding: {
                                    top: 70
                                }
                            },
                            onHover: function (event) {
                                leftPosition = event.layerX;
                                if (leftPosition == undefined) {
                                    leftPosition = parseInt(event.touches[0].pageX);
                                }
                            },

                            tooltips: {

                                // Disable the on-canvas tooltip
                                enabled: false,

                                custom: function (tooltipModel) {
                                    // Tooltip Element
                                    var tooltipEl = document.getElementById('chartjs-tooltip');


                                    // Create element on first render
                                    if (!tooltipEl) {
                                        tooltipEl = document.createElement('div');
                                        tooltipEl.id = 'chartjs-tooltip';
                                        tooltipEl.innerHTML = '<table style="background: #fff; margin-left: calc(-50% - 6px); position: relative; z-index: 99999; font-weight: 600; border: 2px solid #B6ACA2; border-radius: 6px; padding: 10px; line-height: 28px; font-family: Apercu-Regular; color: #17332e; white-space: nowrap; font-size: 17px; text-align: center; display: block;"></table>';
                                        document.body.appendChild(tooltipEl);
                                    }

                                    // Hide if no tooltip
                                    if (tooltipModel.opacity === 0) {
                                        tooltipEl.style.opacity = 0;
                                        tooltipEl.style.display = 'none';
                                        return;
                                    }

                                    // Set caret Position
                                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                                    if (tooltipModel.yAlign) {
                                        tooltipEl.classList.add(tooltipModel.yAlign);
                                    } else {
                                        tooltipEl.classList.add('no-transform');
                                    }

                                    function getBody(bodyItem) {
                                        return bodyItem.lines;
                                    }

                                    // `this` will be the overall tooltip
                                    var position = this._chart.canvas.getBoundingClientRect();
                                    let leftPercent = parseInt((parseInt(tooltipModel.caretX) * 100) / position.width);
                                    let reduceWidth = parseInt(parseInt(tooltipModel.width) / 2);

                                    // Set Text
                                    if (tooltipModel.body) {
                                        var titleLines = tooltipModel.title || [];
                                        var bodyLines = tooltipModel.body.map(getBody);

                                        var innerHtml = '<thead>';

                                        titleLines.forEach(function (title) {
                                            innerHtml += '<tr><th style="font-size: 15px; line-height: 18px; padding: 0px;display: block; font-weight: normal;">' + title + '</th></tr>';
                                        });
                                        innerHtml += '</thead><tbody>';

                                        bodyLines.forEach(function (body, i) {
                                            var colors = tooltipModel.labelColors[i];

                                            if (leftPercent > 94) {
                                                var span = '<span style="position: absolute; bottom: -7px; right: 0; margin-left: 0px; width: 0; height: 0; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #B6ACA2;"></span>';
                                            } else {
                                                var span = '<span style="position: absolute; bottom: -7px; left: 50%; margin-left: -6px; width: 0; height: 0; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #B6ACA2;"></span>';                                       
                                            }
                                            innerHtml += '<tr><td>' + span + body + '</td></tr>';
                                        });
                                        innerHtml += '</tbody>';

                                        var tableRoot = tooltipEl.querySelector('table');
                                        tableRoot.innerHTML = innerHtml;
                                    }

                                    // Display, position, and set styles for font
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl.style.display = 'block';
                                    if ($(window).width() < 980) {
                                        setTimeout(() => {
                                            tooltipEl.style.display = 'none';
                                        }, 3000)
                                    }
                                    tooltipEl.style.position = 'absolute';
                                    if (leftPercent > 94) {
                                        tooltipEl.style.left = parseInt(position.left) + window.pageXOffset + tooltipModel.caretX + -reduceWidth + 'px';
                                    } else {
                                        tooltipEl.style.left = parseInt(position.left) + window.pageXOffset + tooltipModel.caretX + 'px';
                                    }
                                    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + -85 + 'px';
                                    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                                    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                                    tooltipEl.style.pointerEvents = 'none';
                                }
                            },
                            maintainAspectRatio: false,
                            responsive: true,
                            legend: {
                                labels: {
                                    fontColor: '#8ba6c1)'
                                },
                                display: false
                            },
                            scales: {
                                yAxes: [{
                                    ticks: this.state.negativeValues ? {
                                        display: true,
                                        fontColor: "#B6ACA2",
                                        fontSize: 14,
                                        beginAtZero: true,
                                        min: -2,
                                        max: 4
                                    } : {
                                        fontColor: "#B6ACA2",
                                        fontSize: 14,
                                        beginAtZero: true
                                    },
                                    gridLines: {
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.props.data.YlabelString,
                                        fontFamily: 'Apercu-Regular',
                                        fontColor: '#B6ACA2',
                                        fontSize: 14
                                    }
                                }],
                                xAxes: [{
                                    display: false,
                                    offset: true,
                                    ticks: {
                                        fontColor: "#B6ACA2",
                                        fontSize: 14,
                                        fontFamily: 'Apercu-Regular'
                                    },
                                    gridLines: {
                                        lineWidth: 0,
                                        display: false,
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: "",// this.props.data.XlabelString,
                                        fontFamily: 'Apercu-Regular',
                                        fontColor: '#B6ACA2',
                                        fontSize: 14
                                    }
                                }]
                            }

                        }
                    });
                }
                catch (error) {
                }
                //---------------------------------List Chart
                try {

                    this.setState({

                        columnData: apidata[0].listDataSet
                    });
                }
                catch (error) { }
            }).catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true,
                    noDataDisplay: 'Error while loading data'
                });
            });
    }
    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber });
    }
    handleLine(event) {
        $(event.target).parent().parent().next().toggleClass('flipped');
        $(event.target).parent().next().toggleClass('active');
        $(event.target).parent().parent().toggleClass('active');
    }
    handleList(event) {
        $(event.target).parent().parent().next().toggleClass('flipped');
        $(event.target).parent().prev().toggleClass('active');
        $(event.target).parent().parent().toggleClass('active');
    }
    render() {
        var tooltipColor1;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            tooltipColor1 = ColorJson.ApplicationColor.Rxhacker_secondary_color;
        } else {
            tooltipColor1 = "#2a524b";
        }
        const tooltipColor2 = this.props.data.ColorCode;
        const userlistobj = JSON.parse(JSON.stringify(this.state.columnData));
        userlistobj.splice(0, 1);
        let paging = 0;
        paging = userlistobj.length % 6 != 0 ? userlistobj.length + 6 - userlistobj.length % 6 : userlistobj.length;
        return (
            <div className="bar">
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>)}
                <div className="flip-section">
                    <div className="widget-head mobile-position">
                        <h3>
                            <a>
                                {
                                    this.props.data.title != "Client Access Link Signups" && this.props.data.title != "New vs Repeat Transactions" ?
                                        <span>$ {this.state.sumOfLegendValue + " "}</span> :
                                        <span>{this.state.sumOfLegendValue + " "}</span>
                                }
                                <span>{this.state.LegendValue}</span> <span data-title={this.props.data.title} className="transition-title">{this.props.data.title} <p>{this.props.data.Subtitle}</p></span>
                            </a>
                        </h3>
                    </div>
                    <a href="javascript:void('0')" widget-id={this.props.data.id} widget-title={this.props.data.title} className="onlyList custom-tooltip" id={this.props.data.title}><img onClick={this.ExportWidget} widget-title={this.props.data.title} className="export_icon" widget-id={this.props.data.id} src={exportIcon} alt="Export Icon" /><span className="hover-tooltip down-report">Download report</span></a>
                    <label className="mobileExportLabel" widget-title={this.props.data.title} widget-id={this.props.data.id} onClick={this.ExportWidget}>Export</label>
                    <a className="mobileListIcon" href="javascript:void('0')" onClick={this.mobileMenu}>
                        <span className="dot">;&nbsp</span>
                        <span className="dot">;&nbsp</span>
                        <span className="dot">;&nbsp</span>
                    </a>
                    <div className="flip-icons">
                        <a href="javascript:void('0')" className="custom-tooltip">
                            <img className="bar_chart_icon" src={BarChartIcon} alt="barcharticon" />
                            <img onClick={this.handleBarList} className="mobile_bar_icon" src={BarChartIcon} alt="barcharticon" />
                            <label onClick={this.handleBarList} className="mobileBarLabel">Line</label>
                            <img className="bar_chart_icon inactive" onClick={this.handleLine} src={BarChartIconInactive} alt="barcharticoninactive" />
                            <span className="hover-tooltip bar">Line</span></a>
                        <a href="javascript:void('0')" onClick={this.handleFlip} className="flip_icon">Flip</a>
                        <a href="javascript:void('0')" className="custom-tooltip">
                            <img className="listing-icon" onClick={this.handleList} src={listingIcon} alt="listingicon" />
                            <img className="listing-icon activeicon" src={listingIconActive} alt="listcharticonactive" />
                            <img onClick={this.handleBarList} className="mobile_list_icon" src={listingIconActive} alt="listcharticonactive" />
                            <span className="hover-tooltip list">List</span>
                            <label onClick={this.handleBarList} className="mobileListLabel">List</label>
                        </a>
                    </div>
                    <div className="flip-bg" id={this.state.IFrameId + "_flip_bg_frame"}>
                        <div className="front">
                            <div className="first ">
                                <div className="transitions">
                                    <div className="same-transitions">
                                        <div className="left"><span className="rectangle" style={{ background: tooltipColor1 }}>&nbsp;</span><span className="bold">{this.state.LegendValue1}</span></div>
                                        <div className="right">
                                            <span>{this.state.LegendText1}</span>
                                        </div>
                                    </div>
                                    <div className="same-transitions">
                                        <div className="left"><span className="rectangle" style={{ background: tooltipColor2 }}>&nbsp;</span><span className="bold">{this.state.LegendValue2}</span></div>
                                        <div className="right">
                                            <span>{this.state.LegendText2}</span>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.chartData != null && this.state.chartData.length > 0 && this.state.chartData[0].datasets[0].data.length > 0 ?
                                        <div id={this.state.IFrameId} scrolling="no" key={"graph-frame" + this.state.IFrameId}>
                                            <div className="myChart">
                                                <Line data={this.state.chartData[0]} options={this.state.options} />
                                            </div>
                                        </div>
                                        : <span className="data-not-found">{this.state.noDataDisplay}</span>
                                }
                            </div>
                        </div>
                        <div className="back">
                            <div className="second">
                                <div className="widget-iframe">
                                    <div className="myListChart myColumnChart col-lg-12" id={this.props.data.id}>
                                        {
                                            this.state.columnData != null ?
                                                <div>
                                                    <div className="mobile-scrolling-all tool-section list-data">
                                                        {
                                                            this.state.columnData.length > 1 ?
                                                                <div>
                                                                    {

                                                                        this.state.columnData != null ? this.state.columnData[0] ?
                                                                            <div className="tableheader" key={"TableHeader0"}>
                                                                                {this.state.columnData[0]["datasets"].map((e2, i2) => {
                                                                                    return (
                                                                                        <div key={'xyz' + i2}>{e2.data}</div>
                                                                                    )
                                                                                })}
                                                                            </div> : null : null
                                                                    }
                                                                    <div className="mainList">
                                                                        {
                                                                            (userlistobj.length > 6 ? userlistobj.splice((this.state.activePage - 1) * 6, 6) : userlistobj).map((obj, index) => {
                                                                                return <div className="tablebody" key={"tablebody" + index}>
                                                                                    {obj["datasets"].map((e2, i2) => {
                                                                                        return (
                                                                                            <div key={'xyz' + i2}>{e2.data}</div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                            })
                                                                        }
                                                                    </div>
                                                                    <Pagination
                                                                        activePage={this.state.activePage}
                                                                        itemsCountPerPage={6}
                                                                        totalItemsCount={paging}
                                                                        pageRangeDisplayed={5}
                                                                        onChange={this.handlePageChange.bind(this)}
                                                                    />
                                                                </div>
                                                                : <span className="data-not-found">{this.state.noDataDisplay}</span>
                                                        }
                                                    </div></div> : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default MultiLine_Listchart;
